import axios from 'axios';

const API_BASE_URL = 'https://srivinayagawires.com/api';
// const API_BASE_URL = 'http://localhost/vinayaga_wires/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;